<script setup lang="ts">
  
  import { ref } from 'vue'

  const props = defineProps<{
    value: string
  }>()

  const emit = defineEmits<{
    copied: []
  }>()

  const copied = ref(false);

  const copyToClipboard = async () => {
      try {
        await navigator.clipboard.writeText(props.value);
        copied.value = true;
        emit('copied');

        // Reset the copied message after a timeout
        setTimeout(() => {
          copied.value = false;
        }, 2000);
      } catch (err) {
        console.error("Failed to copy text: ", err);
      }
    };


</script>

<template>
  <button v-tooltip="{
    content: 'Copied!',
    triggers: ['manual'],
    shown: copied,
    autoHide: false,
  }" @click="copyToClipboard">
    <slot>
      <v-icon class="text-base-content/25 hover:text-base-content" name="hi-clipboard-copy" height="1em" width="1em" />
    </slot>
  </button>
</template>

<style>
</style>
